import React from 'react';
import { IconVideo } from '@tabler/icons-react';

export default function DefaultPreview() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex h-full w-full items-center justify-center rounded bg-slate-200 hover:bg-slate-100">
        <IconVideo size={32} stroke={1.5} className="text-slate-500" />
      </div>
    </div>
  );
}
